





import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Message extends Vue {
    show: boolean = false;

    constructor() {
        super();
    }
    mounted() {
        this.$root.$on('show-message', () => {
            this.show = true;
            setTimeout(() => {
                this.show = false;
            }, 1000);
        });
    }
}
